import { NaverPixelItems } from '@repo/tracking-service';

export const getNaverPixelItems = (businessType: string, incomeAmount: number, tritxAmount: number) => {
  const naverItems: NaverPixelItems[] = [
    {
      id: `${businessType}-income`,
      name: 'income',
      quantity: 1,
      payAmount: incomeAmount
    }
  ];
  if (tritxAmount) {
    naverItems.push({
      id: 'indis-tritx',
      name: 'gains',
      quantity: 1,
      payAmount: tritxAmount
    });
  }

  return naverItems;
};
